const AppItemType = {
    // 视图表单
    ViewList: 'ViewList',
    // 工作流表单
    WorkflowList: 'WorkflowList',
    // 普通表单
    GridList: 'GridList',
    // 文件列表
    FileList: 'FileList',
    //外部数据源列表
    ExDatasourceList: 'ExDatasourceList',
    // 树列表
    TreeList: 'TreeList',
    //邮件列表
    MailList: 'MailList',
};

export default AppItemType;
